import React from 'react';
import UploadItemContainer from '../containers/upload-item-container'
import FlatButton from 'material-ui/FlatButton';
import Header from 'components/header';

import './gallery.css';

const style = {
    gallery: {
        paddingTop: 56,
        paddingBottom: 60
    },
    filler: {
        height: 1,
        background: 'transparent',
        marginBottom: 0
    },

    button: {
        position: 'absolute',
        right: 0,
        top: '50%',
        transform: 'translateY(-50%)',
        height: 40,
        zIndex: 2
    }
};

// Using "Stateless Functional Components"
export default function(props) {

    const listItems = props.assets.map( asset => {
        return <UploadItemContainer
            key={asset.tempUUID}
            userId={props.userId}
            color={'transparent'}
            {...asset}  />;
        //return <a key={asset.id}><img src={href}/></a>
    });

    for (let i = 1; i< 8; i++) {
        listItems.push( <a key={i} style={style.filler}/>);
    }

    return(
        <div style={style.gallery} className="wt-gallery">
            <Header>In Progress
                <FlatButton style={style.button} primary={true} onTouchTap={props.onTouchTap}>Upload</FlatButton>
            </Header>
            {listItems}
        </div>
    );
}
